import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import SectionHeader from "./SectionHeader";
import Reveal from "./Reveal";

const tiers = [
  {
    name: "1 Bedroom",
    unit: "Condo / Apartment",
    price: "$350",
    features: [
      "1-bedroom condo or apartment",
      "Whole-unit specialized treatment",
      "Discreet, professional application",
      "Preparation & aftercare guidance",
    ],
  },
  {
    name: "2 Bedroom",
    unit: "Condo / Apartment",
    price: "$450",
    features: [
      "2-bedroom condo or apartment",
      "Whole-unit specialized treatment",
      "Discreet, professional application",
      "Preparation & aftercare guidance",
    ],
    featured: true,
  },
];

export default function Pricing() {
  return (
    <section id="pricing" className="bg-secondary/40 py-24 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeader
          kicker="Transparent Pricing"
          title="Straightforward bed bug treatment pricing."
          subtitle="Flat-rate pricing for the most common Vancouver condos and apartments. No surprises — the quote you see is the price you pay."
        />
        <div className="mt-14 grid gap-6 sm:grid-cols-2 sm:max-w-3xl">
          {tiers.map((t) => (
            <Reveal key={t.name} delay={t.featured ? 0.1 : 0}>
              <div className={`relative flex h-full flex-col rounded-lg border bg-background p-8 ${t.featured ? "border-accent shadow-sm" : "border-border"}`}>
                {t.featured && (
                  <span className="absolute right-6 top-6 text-[10px] font-semibold uppercase tracking-[0.18em] text-accent">Best Value</span>
                )}
                <p className="text-xs font-semibold uppercase tracking-[0.18em] text-muted-foreground">{t.name}</p>
                <p className="mt-1 text-sm text-muted-foreground">{t.unit}</p>
                <div className="mt-6 flex items-baseline gap-1">
                  <span className="font-heading text-5xl font-extrabold tracking-tight text-primary">{t.price}</span>
                </div>
                <ul className="mt-6 flex-1 space-y-3 text-sm text-muted-foreground">
                  {t.features.map((f) => (
                    <li key={f} className="flex items-start gap-2">
                      <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-accent" />
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
                <Button asChild className="mt-8 h-11 w-full bg-accent text-sm font-semibold text-white hover:bg-accent/90">
                  <a href="#booking">Book This Treatment <ArrowRight className="ml-1 h-4 w-4" /></a>
                </Button>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.1}>
          <p className="mt-8 max-w-2xl text-sm text-muted-foreground">
            Other property types and sizes are quoted based on the details you give us when booking. Final pricing is confirmed before treatment.
          </p>
        </Reveal>
      </div>
    </section>
  );
}